module.exports = __webpack_public_path__ + "static/media/image-card-6.93e296e0.png";